(function() {
    // Wrap in IIFE to avoid global scope pollution
    let resizeTimeout;

    function toggleResponsiveElements() {
        const width = window.innerWidth;
        const isMobile = width <= 991;

        document.querySelectorAll('.mobile_none').forEach(el => {
            el.style.display = isMobile ? 'none' : '';
        });

        document.querySelectorAll('.desktop_none').forEach(el => {
            el.style.display = isMobile ? '' : 'none';
        });
    }

    // ✅ Run initially
    toggleResponsiveElements();

    // ✅ Handle window resize (debounced)
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(toggleResponsiveElements, 100);
    });

    // ✅ Shopify section reload support
    document.addEventListener('shopify:section:load', toggleResponsiveElements);
    document.addEventListener('shopify:section:reloaded', toggleResponsiveElements);

    // ✅ Observe dynamic changes in ProductGridContainer
    document.addEventListener('DOMContentLoaded', () => {
        const target = document.getElementById('ProductGridContainer');
        if (!target) return;

        const observer = new MutationObserver(() => toggleResponsiveElements());
        observer.observe(target, { childList: true, subtree: true });
    });
})();

document.addEventListener('click', function(e) {
  // ✅ Handle remove button separately
  const removeBtn = e.target.closest('delpro-btn button');
  if (removeBtn) {
    const delWrapper = e.target.closest('delpro-btn');
    const lineIndex = delWrapper.dataset.index;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: Number(lineIndex), quantity: 0 })
    })
    .then(res => res.json())
    .then(cart => {
      updateCartUI(cart);
      updateCartCount();
      updateCartSubtotal();
      toggleCheckoutButton();
    })
    .catch(err => console.error('Remove item error:', err));

    return; // ⛔ stop here so qty update below doesn't trigger
  }

  // ✅ Handle quantity buttons
  const plusBtn = e.target.closest('.qty-bt[name="plus"]');
  const minusBtn = e.target.closest('.qty-bt[name="minus"]');
  if (!plusBtn && !minusBtn) return;

  const qtyBox = e.target.closest('.mini-cart-qty-box');
  const input = qtyBox.querySelector('.qty-box-input');
  const lineIndex = input.dataset.index;
  let qty = parseInt(input.value);

  if (plusBtn) qty++;
  if (minusBtn && qty > 1) qty--;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ line: Number(lineIndex), quantity: qty })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartUI(cart);
    updateCartCount();
    updateCartSubtotal();
    toggleCheckoutButton();
  })
  .catch(err => console.error('Qty update error:', err));
});


// ✅ Handle manual quantity input change
document.addEventListener('change', function(e) {
  const input = e.target.closest('.mini-cart-qty-box .qty-box-input');
  if (!input) return;

  const lineIndex = input.dataset.index;
  let qty = parseInt(input.value) || 1;
  if (qty < 1) qty = 1;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ line: Number(lineIndex), quantity: qty })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartUI(cart);
    updateCartCount();
    updateCartSubtotal();
    toggleCheckoutButton();
  })
  .catch(err => console.error('Manual qty change error:', err));
});